const radio_buttons = document.querySelectorAll('.input__radio--single-only');

if (radio_buttons && radio_buttons.length > 0) {
    // Still need to figure out if there are groups.

    [...radio_buttons].map((button) => {
        button.addEventListener('change', (e) => {
            [...radio_buttons].map((other_button) => {
                if (button !== other_button && button.dataset.group === other_button.dataset.group) {
                    other_button.checked = false;
                }
            });
        });
    });
}

// Careers
const careerBoxes = document.querySelectorAll('.job_listings input[type="checkbox"]');
if (careerBoxes) {
  for (var i=0; i < careerBoxes.length; i++) {
    let inputID = careerBoxes[i].id.replace('#', '');
    let label = document.querySelector('label[for='+inputID+']');
    careerBoxes[i].addEventListener('click', (e) => {
      if ( e.target.checked ) {
        e.target.setAttribute('aria-checked', true);
        label.setAttribute('aria-checked', true);
      } else {
        e.target.setAttribute('aria-checked', false);
        label.setAttribute('aria-checked', false);
      }
    });
  }
}

// Contact Page
const contactForm = document.getElementById('contact_form');
if ( contactForm ) {
  contactForm.addEventListener('click', (e) => {
    const radios = contactForm.querySelectorAll('input[type="radio"]');
    for ( var i = 0; i < radios.length; i++ ) {
      if ( radios[i].checked ) {
        radios[i].setAttribute('aria-checked', true);
      } else {
        radios[i].setAttribute('aria-checked', false);
      }
    }
  });
}

// Title VI Related Forms
const preferredContact = document.querySelector('.preferred-row');
if (preferredContact) {
  preferredContact.addEventListener('click', (e) => {
    const radios = preferredContact.querySelectorAll('input[type="radio"]');
    if (radios) {
      for ( var i = 0; i < radios.length; i++ ) {
        if ( radios[i].checked ) {
          radios[i].setAttribute('aria-checked', true);
        } else {
          radios[i].setAttribute('aria-checked', false);
        }
      }
    }
  });
}

const behalf_yes = document.getElementById('yes-behalf');
const behalf_no = document.getElementById('no-behalf');
if (behalf_no && behalf_yes) {
    let target = behalf_no.dataset.target;
    const collapse = document.getElementById(target.replace('#', ''));

    const behalf_no_label = document.querySelector('label[for="'+behalf_no.id.replace('#', '')+'"]');
    const behalf_yes_label = document.querySelector('label[for="'+behalf_yes.id.replace('#', '')+'"]');

    behalf_no.addEventListener('change', (e) => {
        if (e.target.checked) {
            // Set Aria Attributes
            behalf_no.setAttribute('aria-checked', true);
            behalf_yes.setAttribute('aria-checked', false);
            behalf_no_label.setAttribute('aria-checked', true);
            behalf_yes_label.setAttribute('aria-checked', false);

            // Show the hidden container and set attributes.
            collapse.classList.add('show');
            collapse.setAttribute('aria-hidden', false);
            collapse.setAttribute('aria-disabled', false);
        }
    });

    behalf_yes.addEventListener('change', (e) => {
        if (e.target.checked) {
            // Set Aria Attributes
            behalf_yes.setAttribute('aria-checked', true);
            behalf_no.setAttribute('aria-checked', false);
            behalf_no_label.setAttribute('aria-checked', false);
            behalf_yes_label.setAttribute('aria-checked', true);

            // Hide the container and set attributes.
            collapse.classList.remove('show');
            collapse.setAttribute('aria-hidden', true);
            collapse.setAttribute('aria-disabled', true);
        }
    });
}

const permission_yes = document.getElementById('yes-permission');
const permission_no = document.getElementById('no-permission');

if (permission_no && permission_yes) {
    const no_label = document.querySelector('label[for="'+permission_no.id.replace('#', '')+'"]');
    const yes_label = document.querySelector('label[for="'+permission_yes.id.replace('#', '')+'"]');
    permission_no.addEventListener('change', (e) => {
        if (e.target.checked) {
            permission_no.setAttribute('aria-checked', true);
            permission_yes.setAttribute('aria-checked', false);
            no_label.setAttribute('aria-checked', true);
            yes_label.setAttribute('aria-checked', false);
        }
    });

    permission_yes.addEventListener('change', (e) => {
        if (e.target.checked) {
            permission_no.setAttribute('aria-checked', false);
            permission_yes.setAttribute('aria-checked', true);
            no_label.setAttribute('aria-checked', false);
            yes_label.setAttribute('aria-checked', true);
        }
    });
}

const incident_types = document.getElementById('incident_types');
if (incident_types) {
  const incident_array = [
    document.getElementById('incident_other'),
    document.getElementById('incident_origin'),
    document.getElementById('incident_color'),
    document.getElementById('incident_race'),
  ];
  for (var i = 0; i < incident_array.length; i++) {
    incident_array[i].addEventListener('change', (e) => {
      var words = '';
      if ( e.target.checked ) {
        e.target.setAttribute('aria-checked', true);
        document.querySelector('label[for="'+e.target.id.replace('#','')+'"]').setAttribute('aria-checked', true);
      }
      else {
        e.target.setAttribute('aria-checked', false);
        document.querySelector('label[for="'+e.target.id.replace('#','')+'"]').setAttribute('aria-checked', false);
      }
      if (incident_array[0].checked) {
        document.getElementById('incident_other-collapse').classList.add('show');
        document.getElementById('incident_other-collapse').setAttribute('aria-hidden', false);
      } else {
        document.getElementById('incident_other-collapse').classList.remove('show');
        document.getElementById('incident_other-collapse').setAttribute('aria-hidden', true);
      }
    });
  }
}

const add_person = document.getElementById('add-person');

if (add_person) {
    const person_list = document.getElementById('persons-involved-list');
    const element = person_list.querySelector('.form-row');

    add_person.addEventListener('click', (e) => {
        e.preventDefault();
        const newElement = element.cloneNode(true);
        const inputs = newElement.querySelectorAll('input');

        // Create a close button for the new row
        var closeBtn = document.createElement('i');
        closeBtn.classList = 'far fa-times-circle fa-2x';
        closeBtn.style.display = 'block';
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.position = 'absolute';
        closeBtn.style.bottom = '20px';
        closeBtn.style.right = '-32px';

        // Add a click listener
        closeBtn.addEventListener('click', removeRow);

        // Append close button to the new row
        newElement.appendChild(closeBtn);

        // Increment new element ID & name values
        var newNum = parseInt(inputs[0].id[inputs[0].id.length -1]) + 1;
        console.log(newNum);
        inputs[0].id = 'person-'+newNum;
        inputs[0].name = 'person_involved_'+newNum;
        inputs[1].id = 'involved-contact-'+newNum;
        inputs[1].name = 'person_contact_'+newNum;

        if (inputs.length > 0) {
            [...inputs].map(input => input.value = '');
        }

        person_list.appendChild(newElement);
    });
}


const add_witness = document.getElementById('add-witness');

if (add_witness) {
    const witness_list = document.getElementById('witness-involved-list');
    const element = witness_list.querySelector('.form-row');

    add_witness.addEventListener('click', (e) => {
        e.preventDefault();
        const newElement = element.cloneNode(true);
        const inputs = newElement.querySelectorAll('input');

        // Create a close button for the new row
        var closeBtn = document.createElement('i');
        closeBtn.classList = 'far fa-times-circle fa-2x title__close';

        // Add a click listener
        closeBtn.addEventListener('click', removeRow);

        // Append close button to the new row
        newElement.appendChild(closeBtn);
        
        // Increment new element ID & name values
        var newNum = parseInt(inputs[0].id[inputs[0].id.length -1]) + 1;
        console.log(newNum);
        inputs[0].id = 'witness-'+newNum;
        inputs[0].name = 'witness_name_'+newNum;
        inputs[1].id = 'witness-contact-'+newNum;
        inputs[1].name = 'witness_contact_'+newNum;

        if (inputs.length > 0) {
            [...inputs].map(input => input.value = '');
        }

        witness_list.appendChild(newElement);
    });
}

// This will remove any added rows
function removeRow(e){
    var theRow = e.target.parentNode;
    theRow.parentNode.removeChild(theRow);
}

// Expand/Collapse Filed/Unfiled options
const filed_no = document.getElementById('filed');
const filed_yes = document.getElementById('unfiled');

if (filed_no && filed_yes) {
    let target = filed_no.dataset;
    // console.log(filed_no.dataset);
    const collapse = document.getElementById('filed_options');
    
    filed_no.addEventListener('change', (e) => {
        if (e.target.checked) {
            // Set Aria Attributes
            filed_no.setAttribute('aria-checked', true);
            filed_yes.setAttribute('aria-checked', false);

            // Show the hidden container and set attributes.
            collapse.classList.add('show');
            collapse.setAttribute('aria-hidden', false);
            collapse.setAttribute('aria-disabled', false);
        }
    });

    filed_yes.addEventListener('change', (e) => {
        if (e.target.checked) {
            // Set Aria Attributes
            filed_yes.setAttribute('aria-checked', true);
            filed_no.setAttribute('aria-checked', false);

            // Hide the container and set attributes.
            collapse.classList.remove('show');
            collapse.setAttribute('aria-hidden', true);
            collapse.setAttribute('aria-disabled', true);
        }
    });
}

const filedOptions = document.getElementById('filed_options')
if (filedOptions) {
    var filedCheckboxes = filedOptions.querySelectorAll('.input__checkbox');
}
if (filedCheckboxes) {
    for ( var i=0; i < filedCheckboxes.length; i++ ) {
        filedCheckboxes[i].addEventListener('change', toggleFiledFields);
    }
}
function toggleFiledFields(e) {
    var collapse = e.target.parentNode.querySelector('.collapse');
    if (e.target.checked) {
        collapse.classList.add('show');
    } else {
        collapse.classList.remove('show');
    }
}


// Board Of Directors App Form
const bod_form = document.getElementById('bod_form');
if (bod_form) {
  const bod_pref_contact = document.getElementById('bod_pref_contact');
  if (bod_pref_contact) {
    bod_pref_contact.addEventListener('click', (e) => {
      const radios = bod_pref_contact.querySelectorAll('input[type="radio"]');
      if (radios) {
        for ( var i = 0; i < radios.length; i++ ) {
          if ( radios[i].checked ) {
            radios[i].setAttribute('aria-checked', true);
          } else {
            radios[i].setAttribute('aria-checked', false);
          }
        }
      }
    });
  }

  const yes_relations = document.getElementById('yes-relation');
  const no_relations = document.getElementById('no-relation');
  const explanation = document.getElementById('yes_relations_explanation');
  const yes_rel_label = document.querySelector('label[for="yes-relation"]');
  const no_rel_label = document.querySelector('label[for="no-relation"]');

  if (yes_relations) {
    yes_relations.addEventListener('click', (e) => {
      if (e.target.checked) {
        explanation.classList.add('show');
        e.target.setAttribute('aria-checked', true);
        yes_rel_label.setAttribute('aria-checked', true);
        no_relations.setAttribute('aria-checked', false);
        no_rel_label.setAttribute('aria-checked', false);
      }
    });
  }

  if (no_relations) {
    no_relations.addEventListener('click', (e) => {
      if (e.target.checked) {
        explanation.classList.remove('show');
        e.target.setAttribute('aria-checked', true);
        no_rel_label.setAttribute('aria-checked', true);
        yes_relations.setAttribute('aria-checked', false);
        yes_rel_label.setAttribute('aria-checked', false);
      }
    });
  }

  const bod_skills = document.getElementById('bod_skills');
  if (bod_skills) {
    const skill_boxes = bod_skills.querySelectorAll('input[type="checkbox"]');
    if (skill_boxes) {
      for (var i = 0; i < skill_boxes.length; i++) {
        skill_boxes[i].addEventListener('change', (e) => {
          if (e.target.checked) {
            e.target.setAttribute('aria-checked', true);
            var label_name = e.target.id.replace('#', '');
            document.querySelector('label[for="'+label_name+'"]').setAttribute('aria-checked', true);
          } else {
            e.target.setAttribute('aria-checked', false);
            var label_name = e.target.id.replace('#', '');
            document.querySelector('label[for="'+label_name+'"]').setAttribute('aria-checked', false);
          }
        });
      }
    }
  }

  const bod_bg_check = document.getElementById('bod_bg_check');
  if (bod_bg_check) {
    bod_bg_check.addEventListener('click', (e) => {
      const radios = bod_bg_check.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        radios[i].setAttribute('aria-checked', false);
        radios[i].nextElementSibling.setAttribute('aria-checked', false);
      }
      const selected = bod_bg_check.querySelector('input[type="radio"]:checked');
      if (selected) {
        selected.setAttribute('aria-checked', true);
        selected.nextElementSibling.setAttribute('aria-checked', true);
      }
    });
  }

// End Board Of Directors Form
}


// -----------
// Submissions
// -----------

// Buttons and Listeners
const contactSubmitBtn = document.getElementById('contact_submit');
if (contactSubmitBtn) {
  contactSubmitBtn.addEventListener('click', submitContactForm);
}

const programSubmitBtn = document.getElementById('program_submit');
if (programSubmitBtn) {
    programSubmitBtn.addEventListener('click', submitContactForm);
}

const titleviSubmitBtn = document.getElementById('complaint_submit');
if (titleviSubmitBtn) {
    titleviSubmitBtn.addEventListener('click', submitContactForm);
}

const bodSubmitBtn = document.getElementById('bod_app_submit');
if (bodSubmitBtn) {
  bodSubmitBtn.addEventListener('click', submitContactForm);
}

// Ajax submission
function submitContactForm(e) {
  var form = e.target.id;
  var valid = e.target.form.checkValidity();
  if (valid && form !== 'bod_app_submit' && form !== 'complaint_submit') {
      e.preventDefault();
      var subStatus = document.getElementById('submit_status');
      subStatus.innerHTML = 'Sending...';
      var name = document.getElementById('name').value;
      var email = document.getElementById('email').value;
      if (form === 'contact_submit') {
          var pref = document.querySelector('input[name="preferred[]"]:checked').value;
          var day = document.getElementById('day').value;
          var eve = document.getElementById('evening').value;
          var msg = document.getElementById('message').value;
      } else if ( form === 'program_submit' ) {
          var phone = document.getElementById('phone').value;
          var msg = document.getElementById('message').value;
      } else if ( form === 'bod_app_submit' ) {

      }
      // Setup ajax request.
      var request = new XMLHttpRequest();
      request.open('POST', phpVars.ajaxURL, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      request.onload = function() {
          if ( this.status >= 200 && this.status < 400 ) {
              console.log(this.response);
              // Reset the form and disable fields
              var currentForm = document.getElementById('request');
              if (!currentForm) { var currentForm = document.getElementById('contact_form'); }
              if (currentForm) {
                currentForm.reset();
                document.getElementById(form).disabled = true;
                var formElements = currentForm.elements;
                for (var i = 0, len = formElements.length; i < len; ++i) {
                    formElements[i].readOnly = true;
                }
                // Set status message
                subStatus.innerHTML = 'Sent!';
                setTimeout(function(){
                    subStatus.innerHTML = '';
                }, 5000);
              }
          } else {
              console.log(this.response);
              // Set status message
              subStatus.innerHTML = 'Something went wrong...';
              setTimeout(function(){
                  subStatus.innerHTML = '';
              }, 5000);
          }
      }
      request.onerror = function() {
          console.log('Connection error...');
              subStatus.innerHTML = 'Connection error...';
              setTimeout(function(){
                  subStatus.innerHTML = '';
              }, 5000);
      }
      if ( form === 'contact_submit') {
          request.send('action=contact_form_submit&name='+name+'&email='+email+'&pref='+pref+'&msg='+msg+'&day='+day+'&eve='+eve+'&form='+form);
      } else if ( form === 'program_submit' ) {
          request.send('action=contact_form_submit&name='+name+'&email='+email+'&msg='+msg+'&phone='+phone+'&form='+form);
      } 
  }
  // If the form is the titlevi form, do some custom validation
  else if ( form === 'complaint_submit' ) {
      e.preventDefault();
      // Setup empty array to hold the fields that don't pass validation
      var badFields = [];
      var form = document.getElementById('request');
      // Select all fields in the form that are deemed invalid
      var formFields = form.querySelectorAll('input:invalid');
      for ( var i=0; i < formFields.length; i++ ) {
          // If the field is visible add it to the badFields array and show the alert
          if ( formFields[i].offsetWidth > 0 && formFields[i].offsetHeight > 0 ) {
              console.log(formFields[i]);
              badFields.push(formFields[i]);
              formFields[i].parentNode.querySelector('.alert').classList.remove('invalid-feedback');
          }
      }
      // If we have bad fields scroll to the first one
      if (badFields !== undefined && badFields.length > 0) {
            console.log(badFields);
            badFields[0].parentNode.scrollIntoView();
      }
      else {
          // grab various fields
          var formElem = document.getElementById('request');
          var formData = new FormData(formElem);
          formData.append('action', 'contact_form_submit');
          formData.append('form', 'complaint');
          console.log('We got it all');
          var subStatus = document.getElementById('submit_status');
          subStatus.innerHTML = 'Sending...';
          // Setup ajax request.
          var request = new XMLHttpRequest();
          request.open('POST', phpVars.ajaxURL, true);
          request.setRequestHeader('accept', 'application/json');
          request.onload = function() {
              if ( this.status >= 200 && this.status < 400 ) {
                  console.log(this.response);
                  // Reset the form and disable fields
                  var currentForm = document.getElementById('request');
                  currentForm.reset();
                  currentForm.disabled = true;
                  var formElements = currentForm.elements;
                  for (var i = 0, len = formElements.length; i < len; ++i) {
                      formElements[i].readOnly = true;
                  }
                  // Set status message
                  subStatus.innerHTML = 'Sent!';
                  setTimeout(function(){
                      subStatus.innerHTML = '';
                  }, 5000);
              } else {
                  console.log(this.response);
                  // Set status message
                  subStatus.innerHTML = 'Something went wrong...';
                  setTimeout(function(){
                      subStatus.innerHTML = '';
                  }, 5000);
              }
          }
          request.onerror = function() {
              console.log('Connection error...');
                  subStatus.innerHTML = 'Connection error...';
                  setTimeout(function(){
                      subStatus.innerHTML = '';
                  }, 5000);
          }
          // request.send(formData);
          // for (var [key, value] of formData.entries()) { 
          //     console.log(key, value);
          //   } 
          request.send(formData);
      }
  }
  else if ( valid && form === 'bod_app_submit' ) {
    e.preventDefault();
    // grab various fields
    var formElem = document.getElementById('bod_form');
    var formData = new FormData(formElem);
    formData.append('action', 'contact_form_submit');
    formData.append('form', 'bod');
    console.log('We got it all');
    var subStatus = document.getElementById('submit_status');
    subStatus.innerHTML = 'Sending...';
    // Setup ajax request.
    var request = new XMLHttpRequest();
    request.open('POST', phpVars.ajaxURL, true);
    request.setRequestHeader('accept', 'application/json');
    request.onload = function() {
        if ( this.status >= 200 && this.status < 400 ) {
            console.log(this.response);
            // Reset the form and disable fields
            var currentForm = document.getElementById('bod_form');
            currentForm.reset();
            currentForm.disabled = true;
            var formElements = currentForm.elements;
            for (var i = 0, len = formElements.length; i < len; ++i) {
                formElements[i].readOnly = true;
            }
            // Set status message
            subStatus.innerHTML = 'Sent!';
            setTimeout(function(){
                subStatus.innerHTML = '';
            }, 5000);
        } else {
            console.log(this.response);
            // Set status message
            subStatus.innerHTML = 'Something went wrong...';
            setTimeout(function(){
                subStatus.innerHTML = '';
            }, 5000);
        }
    }
    request.onerror = function() {
        console.log('Connection error...');
            subStatus.innerHTML = 'Connection error...';
            setTimeout(function(){
                subStatus.innerHTML = '';
            }, 5000);
    }
    // request.send(formData);
    // for (var [key, value] of formData.entries()) {
    //     console.log(key, value);
    //   }
    request.send(formData);

  }
}

